// extracted by mini-css-extract-plugin
export var caption = "Image-module--caption--bG3i6";
export var component = "Image-module--component--gFeR2";
export var credit = "Image-module--credit--XsXz4";
export var link = "Image-module--link--vvVOv";